/** Accordion expand persistence prefix for import file sections. */
export const CSV_IMPORT_EXPAND_PREFIX = 'csv-import';

export const CSV_FILE_EXTENSION = '.csv' as const;
export const XLSX_FILE_EXTENSION = '.xlsx' as const;

/** File extensions accepted by the kalkyl importer. */
export const IMPORTABLE_FILE_EXTENSIONS: readonly string[] = [
  CSV_FILE_EXTENSION,
  XLSX_FILE_EXTENSION,
];

/**
 * MIME types a browser may report for `.csv` files. Empty strings are common
 * for text files dragged from disk, so callers should treat an empty type as
 * "possibly CSV" and fall back to extension validation.
 */
export const CSV_MIME_TYPES: readonly string[] = [
  'text/csv',
  'application/csv',
  'application/vnd.ms-excel',
];

export const XLSX_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' as const;

/** All MIME types accepted by the kalkyl importer. */
export const IMPORTABLE_MIME_TYPES: readonly string[] = [
  ...CSV_MIME_TYPES,
  XLSX_MIME_TYPE,
];
